import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, LL_V_L, ModuleFE_Dialog, performAction, stopPropagation, ToastBuilder, TS_Dialog, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { cloneObj, Second } from '@nu-art/ts-common';
import { QToastContent } from '../../../q-components/index.js';
import { ICONS } from '@app/styles';
import { ModuleFE_Reference } from '../../../../_entity.js';
export class Dialog_ArticleEditor extends TS_Dialog {
    // ######################### Static #########################
    static show(onRefUpsertCallback, reference) {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_ArticleEditor, { onRefUpsertCallback: onRefUpsertCallback, reference: reference }), closeOverlayOnClick: () => true });
    }
    static defaultProps = {
        dialogId: 'dialog-article-editor',
    };
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.data = nextProps.reference?.data ?? {
            name: '',
            url: '',
            journal: '',
            publicationYear: 0,
        };
        return state;
    }
    // ######################### Logic #########################
    linkIsDOI = (link) => {
        return true;
    };
    canBeSaved() {
        return this.linkIsDOI(this.state.data.url);
    }
    handleSave = async () => {
        await performAction(async () => {
            this.setState({ dialogIsBusy: true });
            try {
                const ref = this.props.reference && cloneObj(this.props.reference) || {
                    type: 'article',
                    uid: '',
                };
                ref.data = this.state.data;
                const newRef = await ModuleFE_Reference.v1.upsert(ref).executeSync();
                this.props.onRefUpsertCallback(newRef, newRef);
                ModuleFE_Dialog.close();
            }
            catch (e) {
                this.logError(e);
            }
            finally {
                this.setState({ dialogIsBusy: false });
            }
        }, { type: 'notification', notificationLabels: 'Saving Article Reference' });
    };
    // ######################### Render #########################
    renderLinkInput() {
        return _jsxs(LL_V_L, { className: 'match_width', children: [_jsx("span", { className: 'dialog__field-title', children: "Link" }), _jsx(TS_Input, { type: 'text', placeholder: 'Enter Link', value: this.state.data.url, tabIndex: 0, onKeyDown: (e) => {
                        if (!((e.ctrlKey || e.metaKey) && e.key === 'v')) {
                            stopPropagation(e);
                        }
                        if (e.key === 'Backspace') {
                            this.state.data.url = '';
                            this.forceUpdate();
                        }
                    }, onChange: link => {
                        if (!this.linkIsDOI(link)) {
                            new ToastBuilder().setDuration(6 * Second)
                                .setContent(QToastContent({ iconKey: 'x', content: 'Link is not an UpToDate link', toastType: 'error' }))
                                .show();
                        }
                        else {
                            const cleanLink = link.split('?')[0];
                            const split = cleanLink.split('/');
                            this.state.data.url = cleanLink;
                            this.state.data.name = split[split.length - 1];
                            this.forceUpdate();
                        }
                    } })] });
    }
    renderName() {
        return _jsxs(LL_V_L, { children: [_jsx("span", { className: 'dialog__field-title', children: "Name" }), _jsx(TS_Input, { type: 'text', value: this.state.data.name, onChange: (value) => {
                        this.state.data.name = value;
                        this.forceUpdate();
                    } })] });
    }
    renderPublicationYear() {
        return _jsxs(LL_V_L, { children: [_jsx("span", { className: 'dialog__field-title', children: "Publication Year" }), _jsx(TS_Input, { type: 'number', value: String(this.state.data.publicationYear), onChange: (value) => {
                        this.state.data.publicationYear = Number(value);
                        this.forceUpdate();
                    } })] });
    }
    renderJournal() {
        return _jsxs(LL_V_L, { children: [_jsx("span", { className: 'dialog__field-title', children: "Journal" }), _jsx(TS_Input, { type: 'text', value: this.state.data.journal, onChange: (value) => {
                        this.state.data.journal = value;
                        this.forceUpdate();
                    } })] });
    }
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsxs("div", { className: "header__title", children: [this.props.reference ? 'Edit' : 'Add', " Article"] }), _jsx("div", { className: "header__buttons", children: _jsx(ICONS.x.component, { className: "exit_icon", onClick: () => ModuleFE_Dialog.close() }) })] });
    };
    renderBody = () => {
        return _jsxs(_Fragment, { children: [this.renderLinkInput(), this.renderName(), this.renderJournal(), this.renderPublicationYear()] });
    };
    buttons = () => {
        return {
            right: [
                {
                    content: 'Cancel',
                    onClick: () => ModuleFE_Dialog.close(),
                },
                {
                    content: 'Save',
                    onClick: this.handleSave,
                    disabled: !this.canBeSaved() || this.state.dialogIsBusy,
                    className: _className(this.canBeSaved() ? 'desired-action-button' : ''),
                }
            ],
        };
    };
}
//# sourceMappingURL=Dialog_ArticleEditor.js.map